<template>
  <div id="IndexAbouts" class="body--wrapper">
    <!-- SUB HEADER TOP -->
		<section class="sub--header diagonal-shadow mg-bottom-diagonal">
			<div class="container">
				<div class="row">
					<div class="col-md-8">
						<div class="box-desc">
							<div class="title">
								About us
							</div>
							<div class="description">
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?
							</div>
							<br>
							<router-link :to="'apply-project'" class="btn btn-lg btn-warning">
							  Konsultasikan pada kami
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /.SUB HEADER TOP -->
		<!-- ABOUT US -->
		<section class="section--wrapper bg-white">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="box-information">
							<div class="title--top">
								<div class="title">
									about us
								</div>
								<div class="description">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo dolore ipsum, autem ipsa est doloribus iure necessitatibus impedit explicabo optio nihil assumenda velit dignissimos vel, sapiente aperiam voluptatibus accusantium eius.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="text-center">
							<a href="#" class="btn btn-lg btn-danger">
								COMPANY PROFILE DOWNLOAD
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /.ABOUT US -->
		<!-- OUR TEAM -->
		<section class="section--wrapper about-us">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="title--top">
							<div class="title txt-white">
								Perkenalkan Team Kami
							</div>
						</div>
					</div>
				</div>
				<div class="row text-center">
					<div class="col-md-12">
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/lutfi.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Lutfi Satria Ramdhani
							</div>
							<div class="box-list-team__position">
								Sistem Analis
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/febry.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Febryan Setiawan
							</div>
							<div class="box-list-team__position">
								Sr.Backend Developer
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/fathan.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Fathan Rohman
							</div>
							<div class="box-list-team__position">
								Sr.Frontend Developer - UI/UX Designer
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/chris.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Christian Tobing
							</div>
							<div class="box-list-team__position">
								Bussines Development
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/farry.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Farry Abimael Argobie
							</div>
							<div class="box-list-team__position">
								Sr.Fullstack Developer
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/jos.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Ramdhani Haris
							</div>
							<div class="box-list-team__position">
								Frontend Developer
							</div>
						</div>
						<div class="box-list-team">
							<div class="box-list-team__image">
								<img src="static/images/team/audi.jpg" alt="">
							</div>
							<div class="box-list-team__name">
								Audi Irawan
							</div>
							<div class="box-list-team__position">
								Mobile Developer
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /.OUR TEAM -->
  </div>
</template>

<script>
export default {
  name: 'IndexAboutus',
  data () {
    return {
      msg: 'Index about'
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// IndexAboutus.vue?2c7e8d43